import { SET_CONTACTS, ADD_CONTACT, DELETE_CONTACT, UPDATE_CONTACT } from '../constants/contacts';
import contactsAPI from '../../_api/contacts';
import { reset, stopSubmit } from 'redux-form';

const setContacts = (data) => ({type: SET_CONTACTS, data: data});
const addContact = (newContact) => ({type: ADD_CONTACT, newContact});
const delContact = (contactId) => ({type: DELETE_CONTACT, contactId});
const setUpdatedContact = (contactId, updatedContact) => ({type: UPDATE_CONTACT, contactId, updatedContact});

export const getContacts = () => async (dispatch) => {
  const response = await contactsAPI.getContacts();
  if (response) dispatch(setContacts(response));
};

export const createContact = (userId, payload) => async (dispatch) => {
  const response = await contactsAPI.createContact(userId, payload);
  if (response) {
    dispatch(addContact(response));
    dispatch(reset('contactForm'));
  } else {
    dispatch(stopSubmit('contactForm', { 'account': gettext(response.data['non_field_errors'][0]) }));
  }
};

export const deleteContact = (contactId) => async (dispatch) => {
  const response = await contactsAPI.deleteContact(contactId);
  if (response) dispatch(delContact(contactId));
};

export const updateContact = (contactId, accountValue) => async (dispatch) => {
  const response = await contactsAPI.updateContact(contactId, accountValue);
  if (response) dispatch(setUpdatedContact(contactId, response));
};

